import { ChangeDetectionStrategy, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { exists } from '../../../../functions/exists';

/**
 * Headless component that loads a remote CSS file into the document head.
 */
@Component({
  selector: 'app-font-family-loader',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FontFamilyLoaderComponent implements OnChanges, OnDestroy {
  @Input() linkToCss: string;

  private linkElement?: HTMLLinkElement;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.linkToCss) {
      this.linkElement?.remove?.();
      if (exists(this.linkToCss)) {
        this.linkElement = document.createElement('link');
        this.linkElement.rel = 'stylesheet';
        this.linkElement.href = this.linkToCss;
        document.head.appendChild(this.linkElement);
      }
    }
  }

  ngOnDestroy(): void {
    this.linkElement?.remove?.();
  }
}
